import * as THREE from 'three'
import Scoll from 'views/Scoll'
let TWEEN = require('@tweenjs/tween.js')

let tani = {t: 0.0, OldY: 0.0}
let scollFun

class Scene1 {
  constructor (loadmodel) {
    this.thisscreen(loadmodel)
      //console.log('开场动画')
  }

  animation (loadmodel) {
    let that = this
    var go = loadmodel.tween(tani).to({t: 0.211}, 2000).easing(TWEEN.Easing.Cubic.InOut).onComplete(function () {
      scollFun = new Scoll()
      scollFun.enable()
      tani.OldY = scollFun.return()
      that.NextScene(loadmodel)
    })
    // let tt = 0
    let loadText = document.getElementById('load_text')
    let lunBox = document.getElementById('lun_box')
    let aImg = [
      'static/images/p1/all1.jpg',
      'static/images/p1/all1_1.jpg',
      'static/images/p1/all2.jpg',
      'static/images/p2/all2.jpg',
      'static/images/p2/all2_1.jpg',
      'static/images/p3/all3.jpg',
      'static/images/p3/all3_1.jpg',
      'static/images/p4/all4.jpg',
      'static/models/1.png',
      'static/models/2.png',
      'static/models/3.png',
      'static/models/4.png',
      'static/models/5.png',
      'static/models/6.png',
      'static/models/7.png',
      'static/models/8.png',
      'static/models/9.png',
      'static/models/10.png',
      'static/models/11.png',
      'static/models/12.png',
      'static/models/13.png',
      'static/models/14.png'
    ]
    var full = aImg.length + 1
    let progress = 1
    let loader = function () {
      for (var i = 0; i < aImg.length; i++) {
        var img = new Image()
        img.src = aImg[i]
        img.onload = function () {
          progress++
          //console.log(progress)
          loadText.innerHTML = parseInt(progress / full * 100) + '%'
          lunBox.style.left = parseInt(progress / full * 100 - 16) + '%'
          if (progress === full) {
            // loaddisbox.delay(3500)
            loaddisbox.start()
            loaddis.delay(2500)
            loaddis.start()
          }
        }
      }
    }
    loader()

    var loadhtml = document.getElementById('loading')
      if(loadhtml){
          var loaddis = loadmodel.tween(loadhtml.style).to({opacity: 0}, 3000).onStart(function () {
              //console.log(tani.t)
          }).onComplete(function () {
              loadhtml.remove()
          })
      }

    var loadbox = document.getElementById('load_box')
    var loaddisbox = loadmodel.tween(loadbox.style).to({opacity: 0}, 1500)
    //
    go.delay(3500)
    go.start()

    // 更新摄像机
    let splineCamera = loadmodel.scene.getObjectByName('s1_camera')
    // splineCamera.up.set(0, -1, 0)
    let tube = loadmodel.scene.getObjectByName('s1_tube')
    let tubeGeometry = tube.geometry
    let _lookat = loadmodel.scene.getObjectByName('s2_destination')
    let __lookat = loadmodel.scene.getObjectByName('s1_lookat')
    let center1 = new THREE.Vector3(__lookat.position.x, __lookat.position.y, __lookat.position.z)
    let center2 = new THREE.Vector3(_lookat.position.x, _lookat.position.y, _lookat.position.z)
    //
    let next = false
    let mainnext = false
    let year = document.getElementById('year')
    loadmodel.camera = splineCamera
    loadmodel.sceneupdate = function () {
      if (!mainnext && tani.t > 0.211) {
        var html = document.getElementById('prog')
        var dis = loadmodel.tween(html.style).to({opacity: 0}, 1000).easing(TWEEN.Easing.Quartic.In).onComplete(function () {
          html.remove()
        })
        dis.delay(50)
        dis.start()
        mainnext = true
      }
      if (tani.t >= 0.211) {
        let nowY = scollFun.return()
        let delta = nowY - tani.OldY
        if (tani.t > 0.511) {
          delta = delta * 0.02
            // delta = delta * 0.005
        } else {
          delta = delta * 0.02
          // delta = delta * 0.005
        }
        if ((tani.t - delta) <= 0.933 && (tani.t - delta) >= 0.211) {
          tani.t = tani.t - delta
        } else if ((tani.t - delta) > 0.933 && next === false) {
          next = true
          loadmodel.tween(tani).to({t: 0.97}, 2000).start()
          var html1 = document.getElementById('white')
          var dis1 = loadmodel.tween(html1.style).to({opacity: 1}, 1800).easing(TWEEN.Easing.Cubic.In)
          dis1.start()
        }
        if (tani.t > 0.511 && tani.t < 0.785) {
          tani.t = 0.786
          loadmodel.tween(year.style).to({opacity: 1}, 200).start()
          for (let i = 1; i <= 14; i++) {
            let j = 's2_plane_' + i.toString()
            let child = this.scene.getObjectByName(j)
            child.visible = true
            child.rotation.z = 2.5 * Math.PI
            child.material.depthTest = false
          }
        }
        if (tani.t < 0.786 && tani.t > 0.512) {
          tani.t = 0.510
          loadmodel.tween(year.style).to({opacity: 0}, 200).start()
          for (let i = 1; i <= 14; i++) {
            let j = 's2_plane_' + i.toString()
            let child = this.scene.getObjectByName(j)
            child.visible = false
            child.rotation.z = 2.5 * Math.PI
            child.material.depthTest = false
          }
        }
        tani.OldY = nowY
      }
      // sdasdf
      if (tani.t < 0.510) {
        let pano1 = loadmodel.scene.getObjectByName('s1_pano')
        pano1.position.copy(loadmodel.camera.position)
      }
      // 光
      let lensFlare = loadmodel.scene.getObjectByName('lens')
      if (tani.t > 0.47 && tani.t < 0.511) {
        let size = (((tani.t - 0.47) / 0.041) * 9300) + 700
        lensFlare.lensFlares[0].size = size
      } else {
        lensFlare.lensFlares[0].size = 700
      }
      // 光
      let lensFlare2 = loadmodel.scene.getObjectByName('lens2')
      if (tani.t >= 0.786 && tani.t < 1) {
        let size = (((tani.t - 0.786) / 0.214) * 3000) + 700
        lensFlare2.lensFlares[0].size = size
      } else {
        lensFlare2.lensFlares[0].size = 700
      }
      if (tani.t < 0.97 && tani.t >= 0) {
        let pos = tubeGeometry.parameters.path.getPointAt(tani.t)
        this.camera.position.copy(pos)
        if (tani.t <= 0.31) {
          splineCamera.position.set(pos.x, pos.y + 310 - tani.t * 1000, pos.z)
        } else {
          splineCamera.position.set(pos.x, pos.y, pos.z)
        }
        if (tani.t > 0.520) {
          splineCamera.lookAt(center2)
          let index = Math.floor((tani.t - 0.786) * 1000 / 5.7)
          year.innerHTML = 2018 - index
         } else if (tani.t <= 0.31) {
          splineCamera.lookAt(center1.x, center1.y + 310 - tani.t * 1000, center1.z)
        } else {
          splineCamera.lookAt(center1)
        }
      } else {
        loadmodel.tween(year.style).to({opacity: 0}, 200).start().onComplete(function () {
          year.style.display = 'none'
        })
          //console.log('开场结束')
        loadmodel.stats = 'overall'
        //loadmodel.stats = 's5_1'

          //console.log('开始全景')
        scollFun.disable()
      }
    }
  }

  NextScene (loadmodel) {
    let pano = new THREE.Group()
    loadmodel.scene.add(pano)
    pano.name = 's3'
    let lookat = loadmodel.scene.getObjectByName('s3_lookat_1')
    let lookat_ = loadmodel.scene.getObjectByName('s4_lookat_1')
    let lookat__ = loadmodel.scene.getObjectByName('s4_radis_3')
    let r = Math.abs(lookat_.position.y - lookat__.position.y)
    let position = lookat.position
    // 添加点
    let dianMaterial = new THREE.MeshBasicMaterial({opacity: 0, transparent: true})
    var list = []
    for (var k = 1; k < 5; k++) {
      list.push(loadmodel.scene.getObjectByName('s3_dian_' + k))
      let e = loadmodel.scene.getObjectByName('s3_dian_' + k)
      loadmodel.scene.remove(e)
    }
    var dianBox
    //console.log(list.length)
    for (var j = 0; j < list.length; j++) {
      dianBox = new THREE.Mesh(new THREE.SphereBufferGeometry(r / 12, 60, 40), dianMaterial)
      dianBox.position.set(list[j].position.x, list[j].position.y, list[j].position.z)
      dianBox.name = 's3_dian' + j
      pano.add(dianBox)
    }
    //console.log(pano)
    //
    let textures = this.getTexturesFromAtlasFile2('static/images/p1/', 'jpg')
    let materials = []
    for (var i = 0; i < 6; i++) {
      materials.push(new THREE.MeshBasicMaterial({map: textures[i]}))
    }
    var skyBox = new THREE.Mesh(new THREE.CubeGeometry(r * 2, r * 2, r * 2), materials)
    skyBox.geometry.scale(-1, 1, 1)
    skyBox.position.set(position.x, position.y, position.z)
    skyBox.rotation.y = Math.PI
    skyBox.name = 's3_pano'
    skyBox.visible = true
    pano.add(skyBox)

    let lineIn = []
    let lineIn0 = loadmodel.scene.getObjectByName('s3_in__1')
    // let lineIn1 = loadmodel.scene.getObjectByName('s3_in__2')
    lineIn.push(lineIn0.position)
    // lineIn.push(lineIn1.position)
    lineIn.push(position)
    let pipeSplineIn = new THREE.CatmullRomCurve3(lineIn)
    let tubeGeometryIn = new THREE.TubeGeometry(pipeSplineIn, 64, 0.02, 8, false)
    let wireframeIn = new THREE.Mesh(tubeGeometryIn)
    wireframeIn.visible = false
    pano.add(wireframeIn)
    wireframeIn.name = 's3_line_in'
    let splineCamera = new THREE.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.0001, 2000)
    splineCamera.name = 's3_camera'
    splineCamera.position.set(lineIn0.position.x, lineIn0.position.y, lineIn0.position.z)
    splineCamera.lookAt(position.x, position.y, position.z)
    pano.add(splineCamera)
    //
    let materialdoor1 = new THREE.MeshBasicMaterial({opacity: 0, transparent: true})
    let OutDoor = loadmodel.scene.getObjectByName('s3_out__1')
    let geometryo = new THREE.SphereBufferGeometry(r / 6, 30, 30)
    let mesho = new THREE.Mesh(geometryo, materialdoor1)
    mesho.position.set(OutDoor.position.x, OutDoor.position.y, OutDoor.position.z)
    mesho.name = 's3_door'
    pano.add(mesho)
  }

  thisscreen (loadmodel) {
    let that = loadmodel
    let ambientLight = new THREE.AmbientLight(0xffffff)
    loadmodel.scene.add(ambientLight)
    loadmodel.scene.visible = true
    let s1 = loadmodel.scene.getObjectByName('s1')
    s1.visible = true
    let vcr = loadmodel.scene.getObjectByName('s1_projector')
    vcr.rotation.z = 1 * Math.PI
    vcr.visible = true
    const foot1 = loadmodel.scene.getObjectByName('s1_turntable_1')
    const foot2 = loadmodel.scene.getObjectByName('s1_turntable_2')
    const foot3 = loadmodel.scene.getObjectByName('s1_turntable_3')
    const foot4 = loadmodel.scene.getObjectByName('s1_turntable_4')
    foot1.rotation.z = 1 * Math.PI
    foot2.rotation.z = 1 * Math.PI
    foot3.rotation.z = 1 * Math.PI
    foot4.rotation.z = 1 * Math.PI
    foot1.visible = true
    foot2.visible = true
    foot3.visible = true
    foot4.visible = true
    var rot1 = new TWEEN.Tween(foot1.rotation).to({x: -2 * Math.PI}, 3000)
    var rot2 = new TWEEN.Tween(foot2.rotation).to({x: -2 * Math.PI}, 3000)
    var rot3 = new TWEEN.Tween(foot3.rotation).to({x: -2 * Math.PI}, 3000)
    var rot4 = new TWEEN.Tween(foot4.rotation).to({x: -2 * Math.PI}, 3000)
    rot1.start().repeat(Infinity)
    rot2.start().repeat(Infinity)
    rot3.start().repeat(Infinity)
    rot4.start().repeat(Infinity)
    // light
    const light1 = loadmodel.scene.getObjectByName('s1_light_1')
    const light10 = loadmodel.scene.getObjectByName('s1_light_10')
    const light2 = loadmodel.scene.getObjectByName('s1_light_2')
    const light20 = loadmodel.scene.getObjectByName('s1_light_20')
    const light3 = loadmodel.scene.getObjectByName('s1_light_3')
    const light30 = loadmodel.scene.getObjectByName('s1_light_30')
    const light4 = loadmodel.scene.getObjectByName('s1_light_4')
    const light40 = loadmodel.scene.getObjectByName('s1_light_40')
    light1.material.depthTest = false
    light10.material.depthTest = false
    light2.material.depthTest = false
    light20.material.depthTest = false
    light3.material.depthTest = false
    light30.material.depthTest = false
    light4.material.depthTest = false
    light40.material.depthTest = false
    light1.visible = true
    light10.visible = true
    light2.visible = true
    light20.visible = true
    light3.visible = true
    light30.visible = true
    light4.visible = true
    light40.visible = true
    // 螺旋
    let s2 = loadmodel.scene.getObjectByName('s2')
    s2.visible = true
    let suidao = loadmodel.scene.getObjectByName('s2_suidao')
    suidao.visible = true
    // 中心点
    let _lookat = loadmodel.scene.getObjectByName('s1_lookat')
    let _radis = loadmodel.scene.getObjectByName('s1_inline_11')
    let r = Math.abs(_radis.position.z - _lookat.position.z)
    let center = new THREE.Vector3(_lookat.position.x, _lookat.position.y, _lookat.position.z)
    let _lookat2 = loadmodel.scene.getObjectByName('s2_lookat')
    let _radis2 = loadmodel.scene.getObjectByName('s2_radis')
    let r2 = Math.abs(_radis2.position.y - _lookat2.position.y)
    let center2 = new THREE.Vector3(_lookat2.position.x, _lookat2.position.y, _lookat2.position.z)
    let line = []

    function a () {
      for (var i = 0; i <= 23; i++) {
        var j = 's1_inline_' + i.toString()
        var child = that.scene.getObjectByName(j)
        line.push(child.position)
      }
    }

    a()
    function b () {
      for (var i = 0; i <= 21; i++) {
        var j = 's1_inline_' + i.toString()
        var child = that.scene.getObjectByName(j)
        line.push(child.position)
      }
    }

    b()
    function c () {
      for (var i = 0; i <= 8; i++) {
        var j = 's1_circle_' + i.toString()
        var child = that.scene.getObjectByName(j)
        line.push(child.position)
      }
    }

    c()
    let point1 = loadmodel.scene.getObjectByName('s2_origin')
    let point2 = loadmodel.scene.getObjectByName('s2_destination')
    line.push(point1.position)
    line.push(point2.position)
    // 2个灯
    let lightPOS = loadmodel.scene.getObjectByName('s1_light')
    let lightPOS2 = loadmodel.scene.getObjectByName('s2_light')
    this.light(0, 0, lightPOS.position.z - 0.2, s1, 'lens')
    this.light(lightPOS2.position.x, lightPOS2.position.y, lightPOS2.position.z, s2, 'lens2')
    // 全景
    let textures = this.getTexturesFromAtlasFile('static/models/sky', 'jpg')
    let materials = []
    for (var i = 0; i < 6; i++) {
      materials.push(new THREE.MeshBasicMaterial({map: textures[i]}))
    }
    var skyBox = new THREE.Mesh(new THREE.CubeGeometry(r * 3, r * 3, r * 3), materials)
    skyBox.geometry.scale(-1, 1, 1)
    skyBox.position.set(center.x, center.y, center.z)
    skyBox.name = 's1_pano'
    skyBox.visible = true
    s1.add(skyBox)
    var skyBox2 = new THREE.Mesh(new THREE.CubeGeometry(r2 * 2, r2 * 2, r2 * 2), materials)
    skyBox2.geometry.scale(-1, 1, 1)
    skyBox2.position.set(center2.x, center2.y, center2.z)
    skyBox2.name = 's2_pano'
    skyBox2.visible = true
    s2.add(skyBox2)
    let splineCamera = new THREE.PerspectiveCamera(84, window.innerWidth / window.innerHeight, 0.005, 20000)
    splineCamera.position.z = -1000
    splineCamera.lookAt(0, 0, 0)
    splineCamera.name = 's1_camera'
    s1.add(splineCamera)
    let pipeSpline = new THREE.CatmullRomCurve3(line)
    let tubeGeometry = new THREE.TubeGeometry(pipeSpline, 64, 0.02, 8, false)
    let wireframeMaterial = new THREE.MeshBasicMaterial({
      color: 0xff0000
    })
    let wireframe = new THREE.Mesh(tubeGeometry, wireframeMaterial)
    wireframe.visible = false
    s1.add(wireframe)
    wireframe.name = 's1_tube'
    this.animation(loadmodel)
  }

  light (x, y, z, group, name) {
    this.addLight(0.995, 0.5, 0.9, x, y, z, group, name)
  }

  addLight (h, s, l, x, y, z, group, name) {
    var textureLoader = new THREE.TextureLoader()
    var textureFlare0 = textureLoader.load('static/textures/lensflare_' + group.name + '/lensflare0.png')
    var textureFlare2 = textureLoader.load('static/textures/lensflare_' + group.name + '/lensflare2.png')
    var textureFlare3 = textureLoader.load('static/textures/lensflare_' + group.name + '/lensflare3.png')
    var flareColor = new THREE.Color(0xffffff)
    flareColor.setHSL(h, s, l)
    var lensFlare = new THREE.LensFlare(textureFlare0, 700, 0.0, THREE.AdditiveBlending, flareColor)
    lensFlare.add(textureFlare2, 512, 0.0, THREE.AdditiveBlending)
    lensFlare.add(textureFlare2, 512, 0.0, THREE.AdditiveBlending)
    lensFlare.add(textureFlare2, 512, 0.0, THREE.AdditiveBlending)
    lensFlare.add(textureFlare3, 60, 0.6, THREE.AdditiveBlending)
    lensFlare.add(textureFlare3, 70, 0.7, THREE.AdditiveBlending)
    lensFlare.add(textureFlare3, 120, 0.9, THREE.AdditiveBlending)
    lensFlare.add(textureFlare3, 70, 1.0, THREE.AdditiveBlending)
    lensFlare.customUpdateCallback = this.lensFlareUpdateCallback
    lensFlare.position.set(x, y, z)
    lensFlare.name = name
    group.add(lensFlare)
  }

  lensFlareUpdateCallback (object) {
    // eslint-disable-next-line
    var f, fl = object.lensFlares.length
    var flare
    var vecX = -object.positionScreen.x * 2
    var vecY = -object.positionScreen.y * 2
    for (f = 0; f < fl; f++) {
      flare = object.lensFlares[f]
      flare.x = object.positionScreen.x + vecX * flare.distance
      flare.y = object.positionScreen.y + vecY * flare.distance
      flare.rotation = 0
    }
    object.lensFlares[2].y += 0.025
    object.lensFlares[3].rotation = object.positionScreen.x * 0.5 + THREE.Math.degToRad(45)
  }

  getTexturesFromAtlasFile (atlasImgUrl, type) {
    var textures = []
    var url = []
    url[0] = atlasImgUrl + 1 + '.' + type
    url[1] = atlasImgUrl + 3 + '.' + type
    url[2] = atlasImgUrl + 4 + '.' + type
    url[3] = atlasImgUrl + 5 + '.' + type
    url[4] = atlasImgUrl + 0 + '.' + type
    url[5] = atlasImgUrl + 2 + '.' + type
    let that = this
    for (var i = 0; i < 6; i++) {
      textures[i] = new THREE.Texture()
      textures[i] = that.getSigleTexture(textures[i], url[i])
    }
    return textures
  }
  getTexturesFromAtlasFile2 (atlasImgUrl, tilesNum) {
    atlasImgUrl = 'static/images/p1/all1.jpg'
    tilesNum = 6
    var textures = []
    for (var i = 0; i < tilesNum; i++) {
      textures[i] = new THREE.Texture()
    }
    var imageObj = new Image()
    imageObj.onload = function () {
      var canvas, context
      var tileWidth = imageObj.height
      for (var i = 0; i < textures.length; i++) {
        canvas = document.createElement('canvas')
        context = canvas.getContext('2d')
        canvas.height = tileWidth
        canvas.width = tileWidth
        context.drawImage(imageObj, tileWidth * i, 0, tileWidth, tileWidth, 0, 0, tileWidth, tileWidth)
        textures[i].image = canvas
        textures[i].needsUpdate = true
      }
    }
    imageObj.src = atlasImgUrl
    return textures
  }

  getSigleTexture (Texture, image) {
    var imageObj = new Image()
    imageObj.onload = function () {
      var canvas, context
      var tileWidth = imageObj.height
      canvas = document.createElement('canvas')
      context = canvas.getContext('2d')
      canvas.height = tileWidth
      canvas.width = tileWidth
      context.drawImage(imageObj, 0, 0, tileWidth, tileWidth, 0, 0, tileWidth, tileWidth)
      Texture.image = canvas
      Texture.needsUpdate = true
    }
    imageObj.src = image
    return Texture
  }
}
export default Scene1



// WEBPACK FOOTER //
// ./src/js/views/Scene1.js